import { useCallback } from "react";

import { DefinedInitialDataOptions, useQuery, UseQueryResult } from "@tanstack/react-query";

import axios from "@/configs/axios";
import { KB_SOURCE } from "@/util/constants";

export interface SecretsData {
  [key: string]: string;
}

export const baseGetSecretsQueryKey = ["/secrets/get_secrets"];

export const useGetSecretsQuery = (
  enabled: boolean = true,
  options?: DefinedInitialDataOptions<SecretsData, Error, SecretsData, string[]>
): UseQueryResult<SecretsData, Error> => {
  const getSecrets = useCallback(async () => {
    const url = `${process.env.REACT_APP_SERVER_HOST}/secrets/get_secrets?source=${KB_SOURCE}`;
    const { data } = await axios.get(url);

    return data;
  }, []);

  const queryResult = useQuery<SecretsData, Error, SecretsData, string[]>({
    ...options,
    queryFn: getSecrets,
    queryKey: [...baseGetSecretsQueryKey, KB_SOURCE],
    enabled: enabled,
  });

  return queryResult;
};
